var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "orderinfo userbox",
      attrs: { id: "orderinfo" }
    },
    [
      _c("div", { staticClass: "userTitle" }, [
        _vm._v(_vm._s(_vm.$t("TradeCards")))
      ]),
      _vm._v(" "),
      _vm.isExchange
        ? _c("div", { staticClass: "exchangeOrder" }, [
            _vm.addressList != null
              ? _c(
                  "div",
                  { staticClass: "exchangeOrderAddress" },
                  [
                    _vm.dislogType.address
                      ? _c("to-address", {
                          attrs: {
                            title: _vm.title,
                            domVisible: _vm.dislogType.address,
                            list: _vm.addressItem,
                            isSet: _vm.isSet
                          },
                          on: { closeDialog: _vm.closeDialog }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "addressShow",
                        class: _vm.isAddShow ? "on" : ""
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "addressList" },
                          _vm._l(_vm.addressList, function(item, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                class: _vm.isAdd == index ? "on" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.setOnlyAddress(index, item)
                                  }
                                }
                              },
                              [
                                _c("div", [
                                  _c("div", { staticClass: "addressName" }, [
                                    _vm._v(
                                      _vm._s(item.City) +
                                        " (" +
                                        _vm._s(item.UserName) +
                                        _vm._s(
                                          _vm.$i18n.locale === "zh" ? "收" : ""
                                        ) +
                                        ")"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "addressText line_txt2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("setProvice")(item.Provice)
                                        ) +
                                          " " +
                                          _vm._s(item.AddressDetail)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "addressPhone" }, [
                                    _vm._v(_vm._s(item.Email))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "addressPhone" }, [
                                    _vm._v(_vm._s(item.Mobile))
                                  ])
                                ]),
                                _vm._v(" "),
                                item.IsDefault
                                  ? _c("span", { staticClass: "default" }, [
                                      _vm._v(_vm._s(_vm.$t("Default")))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "setAddress",
                                    on: {
                                      click: function($event) {
                                        return _vm.setAddress(
                                          "address",
                                          1,
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Edit")))]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "setInfoBox space_between",
                        class: _vm.addressCount > 0 ? "" : "addressShow"
                      },
                      [
                        _vm.addressCount > 3
                          ? _c(
                              "div",
                              {
                                staticClass: "isShow",
                                on: { click: _vm.IsShow }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isAddShow
                                      ? _vm.$t("Hide")
                                      : _vm.$t("ViewAllAddresses")
                                  )
                                )
                              ]
                            )
                          : _c("div", { staticClass: "isShow" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "setinfo",
                            on: {
                              click: function($event) {
                                return _vm.setAddress("address", 0)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("AddNewAddress")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "order_list order_list_title" }, [
                _c("div", { staticClass: "order_list_products" }, [
                  _vm._v(_vm._s(_vm.$t("Cards")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order_list_detail" }, [
                  _vm._v(_vm._s(_vm.$t("ProductName")))
                ])
              ]),
              _vm._v(" "),
              _vm.list != null
                ? _c(
                    "div",
                    { staticClass: "order_list_border exchange_list_border" },
                    [
                      _c("div", { staticClass: "order_list" }, [
                        _c("div", { staticClass: "order_list_products" }, [
                          _c("span", { staticClass: "order_img" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.list.TitImg + "?imageView2/2/w/160"
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "order_list_detail" }, [
                          _c("p", { staticClass: "line_txt3" }, [
                            _vm._v(_vm._s(_vm.list.Title))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "order_num" }, [
                            _vm._v("1")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "order_postage" }, [
                            _vm._v(
                              _vm._s(_vm.$t("Shipping")) +
                                "：" +
                                _vm._s(_vm.$t("PayonDelivery"))
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subTotal" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "" },
                      on: {
                        click: function($event) {
                          return _vm.IsExchange()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "subtn",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.payGo()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("ConfirmRedemption")))]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isExchange
        ? _c("div", { staticClass: "userRightSmallBox" }, [
            _c(
              "div",
              { staticClass: "exchangeBox" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "exchangeRecord",
                    attrs: { to: { path: "/cypher" } }
                  },
                  [_vm._v(_vm._s(_vm.$t("RedemptionHistory")))]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "exchangeLogo",
                  attrs: { src: require("../../../static/images/exchange.png") }
                }),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    attrs: { model: _vm.ruleForm, rules: _vm.rules }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "login_form_item",
                        attrs: { prop: "exchangeCardCode" }
                      },
                      [
                        _c("el-input", {
                          staticClass: "login_ipt",
                          attrs: {
                            placeholder: _vm.$t("verify.RedemptionCode")
                          },
                          on: {
                            input: function($event) {
                              return _vm.setInput()
                            }
                          },
                          model: {
                            value: _vm.ruleForm.exchangeCardCode,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "exchangeCardCode", $$v)
                            },
                            expression: "ruleForm.exchangeCardCode"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "exchange_btn",
                        attrs: { disabled: _vm.disabled, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("ruleForm")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("RedeemNow")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f2f7eda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f2f7eda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/exchange.vue
// module id = null
// module chunks = 